import { TimelineLite, TimelineMax } from "gsap";

const r8Bezier = [{
    x: 0,
    y: 0
}, {
    x: -58,
    y: -120
}, {
    x: 84,
    y: -198
}];

const r9Bezier = [{
    x: 0,
    y: 0
}, {
    x: -50,
    y: -250
}, {
    x: 151,
    y: -314
}];

const vWBezier = [{
    x: 0,
    y: 0
}, {
    x: -58,
    y: -120
}, {
    x: 0,
    y: -183
}];

const variables = {
    factor_12 : document.querySelector('#factor_12'),
    factor_11 : document.querySelector('#factor_11'),
    factor_09 : document.querySelector('#factor_09'),
    factor_07a : document.querySelector('#factor_07a'),
    factor_08 : document.querySelector('#factor_08'),
    factor_vW : document.querySelector('#factor_vW'),
    factor_10 : document.querySelector('#factor_10'),
    factor_05a : document.querySelector('#factor_05a'),
    factor_02a : document.querySelector('#factor_02a'),
    factor_01a : document.querySelector('#factor_01a'),
    factor_13a : document.querySelector('#factor_13a'),
    factor_CLOT : document.querySelector('#factor_CLOT'),

    grey_gear_01 : document.querySelector('#grey_gear_01'),
    grey_gear_02 : document.querySelector('#grey_gear_02'),
    grey_gear_03 : document.querySelector('#grey_gear_03'),
    grey_gear_04 : document.querySelector('#grey_gear_04'),
    grey_gear_05 : document.querySelector('#grey_gear_05'),
    grey_gear_06 : document.querySelector('#grey_gear_06'),
    grey_gear_07 : document.querySelector('#grey_gear_07'),
    grey_gear_08 : document.querySelector('#grey_gear_08'),
    grey_gear_09 : document.querySelector('#grey_gear_09'),

    small_gear_01 : document.querySelector('#small_gear_01'),
    small_gear_02 : document.querySelector('#small_gear_02'),
    small_gear_03 : document.querySelector('#small_gear_03'),
    small_gear_04 : document.querySelector('#small_gear_04'),

    belt_full : document.querySelector('#belt_full'),
    belt_broken : document.querySelector('#belt_broken'),
    hemA_Low_image : document.querySelector('#hemA_Low'),
    hemA_High_image : document.querySelector('#hemA_Hi'),
    hemB_Low_image : document.querySelector('#hemB_Low'),
    hemB_High_image : document.querySelector('#hemB_Hi'),

    factor_replacement_08 : document.querySelector('#factor_replacement_08'),
    factor_replacement_09 : document.querySelector('#factor_replacement_09'),
    factor_replacement_08_div : document.querySelector('#factor_replacement_08_div'),
    factor_replacement_09_div : document.querySelector('#factor_replacement_09_div'),
    factor_replacement_CLOT : document.querySelector('#factor_replacement_CLOT'),
    factor_10_activated : document.querySelector('#factor_10_activated'),
    factor_7a_activated : document.querySelector('#factor_7a_activated'),
    factor_08_activated : document.querySelector('#factor_08_activated'),
    factor_replacement_08_activated : document.querySelector('#factor_replacement_08_activated'),
    factor_replacement_09_activated : document.querySelector('#factor_replacement_09_activated'),

    factor_08_div : document.querySelector('#factor_08_div'),
    factor_09_div : document.querySelector('#factor_09_div'),
    factor_vW_div : document.querySelector('#factor_vW_div'),
    factor_vW_extra : document.querySelector('#factor_vW_extra'),

    factor_replacement_vW : document.querySelector('#factor_replacement_vW'),

    //FACTOR INFO POPUP HANDLERS

    //GSAP Timelines
    //Conditions
    offsetTimeline : new TimelineMax({ repeat: -1 }),
    normalTimeline : new TimelineMax({ repeat: -1 }),
    hemATimeline : new TimelineMax({ repeat: -1 }),
    hemALowTimeline : new TimelineMax({ repeat: -1 }),
    hemAHighTimeline : new TimelineMax({ repeat: -1 }),
    hemBTimeline : new TimelineMax({ repeat: -1 }),
    hemBLowTimeline : new TimelineMax({ repeat: -1 }),
    hemBHighTimeline : new TimelineMax({ repeat: -1 }),
    vWTimeline : new TimelineMax({ repeat: -1 }),

    //Treatments
    r8Timeline : new TimelineMax().to(factor_replacement_08_div, 3, { bezier: { type: 'thru', values: r8Bezier, curviness: 1 }, ease: Power0.easeNone }),
    r8RotateTimeline : new TimelineMax({ repeat: -1 }),
    hemARFTimeline : new TimelineMax({}),
    hemAHiApccTimeline : new TimelineMax({ repeat: -1 }),
    hemAHi7Timeline : new TimelineMax({ repeat: -1 }),

    r9Timeline : new TimelineMax().to(factor_replacement_09_div, 3, { bezier: { type: 'thru', values: r9Bezier, curviness: 1 }, ease: Power0.easeNone }),
    r9RotateTimeline : new TimelineMax({ repeat: -1 }),
    hemBRFTimeline : new TimelineMax({}),
    hemBHiApccTimeline : new TimelineMax({ repeat: -1 }),
    hemBHi7Timeline : new TimelineMax({ repeat: -1 }),

    rvWTimeline : new TimelineMax().to(factor_replacement_vW_div, 3, { bezier: { type: 'thru', values: vWBezier, curviness: 1 }, ease: Power0.easeNone }),
    vWRotateTimeline : new TimelineMax({ repeat: -1 }),
    vWRFTimeline : new TimelineMax({}),
    vWRFVIIITimeline : new TimelineMax({ repeat: -1 }),
    vWDesmopressinTimeline : new TimelineMax({ repeat: -1 }),
    arrayGlossaryPages: document.querySelectorAll('.glossary-page'),

    counters : {
        offsetCounter: 0,
        normalCounter: 0,
        hemACounter: 0,
        hemALowCounter: 0,
        hemAHighCounter: 0,
        hemBCounter: 0,
        hemBLowCounter: 0,
        hemBHighCounter: 0,
        vWCounter: 0,
        hemARFCounter: 0,
        hemAHiApccCounter: 0,
        hemAHi7Counter: 0,
        hemBRFCounter: 0,
        hemBHiApccCounter: 0,
        hemBHi7Counter: 0,
        vWRFCounter: 0,
        vWRFVIIICounter: 0,
        vWDesmopressinCounter: 0,
        innerCarrouselFrameIndexCounter: 1,
        carrouselFrameIndexCounter: 1,
        glossaryPage: 0
    },

    conditionSelected : {
        condition: '',
        inhibitor: '',
        treatment: ''
    },

    factorSelected: '',
    isInWelcome: false,

    bezier : {type: 'thru', values: r8Bezier, curviness: 1}
}

export default variables;



// WEBPACK FOOTER //
// ./src/js/variables.js